export class SetHandsetMode {
  static readonly type = '[app] set handsetMode';
  constructor(public handset: boolean) {}
}
